export default () => {
  function trending(container, facet, maxResults, sectionID, button) {
    // console.log(`🏃‍♂️ Step it, Step it Now!`);
    // console.log(container);

    const {trendingItems} = window["@algolia/recommend-js"];
    const recommend = window["@algolia/recommend"];

    const recommendClient = recommend(
      "MB13IY345Y",
      "5a50c24f3e92ae83f808068a942a1f3b",
    );

    const indexName = "shopify_products";

    const sectionIDIndex = container
      .querySelector("#trending-eliquids-container")
      .getAttribute("sectionIDIndex");

    let itemComponent = "";

    trendingItems({
      container: "#swiper-cards-container",
      recommendClient,
      indexName,
      queryParameters: {
        facetFilters: [`${facet.name}:${facet.value}`],
      },
      threshold: 1,
      facetName: facet.name,
      facetValue: facet.value,
      maxRecommendations: maxResults,
      view(props) {
        container.querySelectorAll(".trending-product-url").forEach((el) => {
          el.remove();
        });

        props.items.filter((item) => {
          container.innerHTML += props.itemComponent({item});
        });

        const cards = document.querySelectorAll(".card-product");

        cards.forEach((item) => {
          const handle = item.dataset.handle;
          getShopifyProduct(item, handle);
        });
      },
      itemComponent({item}) {
        const hasMultiBuy = () => {
          let all = item.tags.toString();
          if (isOutOfStockHelper()) {
            return "";
          } else {
            if (all.includes("Item_pro_Buy")) {
              return `<div class="card-product__badge card-product__multiOffer">Multi Buy</div>`;
            } else {
              return ``;
            }
          }
        };

        const isNew = () => {
          let all = item.collections.toString();
          if (all.includes("new")) {
            return `<div class="card-product__badge card-product__newHighlight">New in</div>`;
          } else {
            return ``;
          }
        };

        const hasFlavour = () => {
          // console.log(data);
          if (item.named_tags.Profile) {
            if (typeof item.named_tags.Profile == "string") {
              return item.named_tags.Profile;
            }
          } else {
            return "";
          }
        };

        const isDisposable = () => {
          let all = item.collections.toString();
          if (all.includes("disposable-vape-kits")) {
            return true;
          } else {
            return false;
          }
        };

        const disposableCount = () => {
          let all = item.tags;
          let c = "";
          all.filter((t, i) => {
            if (t.includes("Profile_")) {
              c = t.replace("Profile_", "");
              return t.replace("Profile_", "");
            } else {
              return "";
            }
          });
          return c;
        };

        const isOutOfStockHelper = () => {
          if (
            item.variants_inventory_count == 0
          ) {
            return true;
          } else {
            return false;
          }
        };

        const isOutOfStock = () => {
          if (
            item.variants_inventory_count <= 0
          ) {
            return `<div class="card-product__oos">Out Of Stock</div>`;
          } else {
            return "";
          }
        };

        const getMultibuyOffer = () => {
          let tags = item.tags.toString();

          if (isOutOfStockHelper()) {
            return "";
          } else {
            if (item.collections) {
              if (tags.includes("Item_pro_Buy any 4 for £10")) {
                return `<div class="card-product__offerText">4 for £10</div>`;
              } else if (tags.includes("Item_pro_Buy any 5 for £20")) {
                return `<div class="card-product__offerText">5 for £20</div>`;
              } else if (tags.includes("Item_pro_Buy any 3 for £10")) {
                return `<div class="card-product__offerText">3 for £10</div>`;
              } else if (tags.includes("Item_pro_Buy any 3 for £20")) {
                return `<div class="card-product__offerText">3 for £20</div>`;
              } else if (tags.includes("Item_pro_Buy any 2 for £25")) {
                return `<div class="card-product__offerText">2 for £25</div>`;
              } else if (tags.includes("Item_pro_Buy any 2 for £20")) {
                return `<div class="card-product__offerText">2 for £20</div>`;
              } else if (tags.includes("Item_pro1_Buy any 3 for £10")) {
                return `<div class="card-product__offerText">3 for £10</div>`;
              } else if (tags.includes("Item_pro1_Buy any 4 for £10")) {
                return `<div class="card-product__offerText">4 for £10</div>`;
              } else if (tags.includes("Item_pro1_Buy any 5 for £20")) {
                return `<div class="card-product__offerText">5 for £20</div>`;
              } else if (tags.includes("Item_pro1_Buy any 5 for £25")) {
                return `<div class="card-product__offerText">5 for £25</div>`;
              } else {
                return "";
              }
            }
          }
        };

        // console.log(item);
        itemComponent = `
          <a id="Swiper-${sectionID}-${sectionIDIndex}"
            class="card-product card-carousel-js embla__slide swiper-slide swiper-slide--${
              facet.name
            } trending-product-url card--visible"
            data-handle="${item.handle}"
            href="/products/${item.handle}"
            data-type="trending">
            <img class="trending-product-img card-product__image" src="${
              item.product_image
            }"/>
            ${hasMultiBuy()}
            ${isNew()}
            ${getMultibuyOffer()}
            ${isOutOfStock()}
            <div style="margin-top: auto; display: contents;">
            <h4 class="trending-product-name card-product__heading">${
              item.title
            }</h4>
            ${
              isDisposable()
                ? `<span class="card-product__flavours">${disposableCount()}</span>`
                : `<span class="card-product__flavours">${hasFlavour()}</span>`
            }
            <div class="option-inject"></div>
            <span class="card-product__price">£${item.price}</span>
            </div>
          </a>
        `;

        // return itemComponent;
        return isOutOfStockHelper() ? '' : itemComponent;
      },
    });

    button.dataset.search = true;

    toggleSlides(container, facet);
  }

  function getShopifyProduct(card, handle) {
    if (handle == undefined || null) {
      return;
    } else {
      const shopifyProductUrl = `/products/${handle}?view=quick-view`;
      // console.log(shopifyProductUrl);
      axios
        .get(shopifyProductUrl)
        .then((response) => {
          addVariantColors(card, response.data);
          return response;
        })
        .catch((error) => error);
    }
  }

  function addVariantColors(card, data) {
    const wrapper = card.querySelector(".option-inject");
    wrapper.innerHTML += data;
  }

  /**
   * Set events listers on items.
   */
  function addEventlistener() {
    const buttons = document.querySelectorAll('[data-trending="toggle"]');
    const defaultButtons = document.querySelectorAll('[data-default="toggle"]');

    const buttonCount = buttons.length;
    if (buttonCount > 0) {
      buttons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();

          const selectorContainer = button.getAttribute(
            "data-target-container",
          );
          const container = document.querySelector(selectorContainer);

          checkToggle(button, container);
        });
      });
    }

    // on a button that isnt trending, hide the trending items and make the other slides visible
    defaultButtons.forEach((button) => {
      const selectorContainer = button.getAttribute("data-target-container");
      const container = document.querySelector(selectorContainer);
      let _type = button.dataset.type;

      // if (_type == "by-range") {
      //   container
      //     .querySelectorAll(
      //       '.swiper-slide:not([data-trending="toggle"]):not([data-type="new-in"])',
      //     )
      //     .forEach((el) => {
      //       el.style.display = "flex";
      //       el.classList.remove("is-hidden");
      //     });
      // } else if (_type == "new-in") {
      //   container
      //     .querySelectorAll(
      //       '.swiper-slide:not([data-trending="toggle"]):not([data-type="by-range"])',
      //     )
      //     .forEach((el) => {
      //       el.style.display = "flex";
      //       el.classList.remove("is-hidden");
      //     });
      // }

      //

      button.addEventListener("click", (e) => {
        const selectorContainer = button.getAttribute("data-target-container");
        const container = document.querySelector(selectorContainer);
        let _type = button.dataset.type;
        // console.log(button.dataset.type);

        // hide other cards and only show the same data type on button click

        container
          .querySelectorAll(
            `.swiper-slide:not([data-trending="toggle"]):not([data-type="${_type}"])`,
          )
          .forEach((el) => {
            el.style.display = "none";
          });

        // if (_type == "new-in") {
        //   container
        //     .querySelectorAll(
        //       '.swiper-slide:not([data-trending="toggle"]):not([data-type="new-in"])',
        //     )
        //     .forEach((el) => {
        //       el.style.display = "none";
        //     });
        // } else if ((_type = "by-range")) {
        //   container
        //     .querySelectorAll(
        //       '.swiper-slide:not([data-trending="toggle"]):not([data-type="by-range"])',
        //     )
        //     .forEach((el) => {
        //       el.style.display = "none";
        //     });
        // }
        e.preventDefault();
        toggleDefault(button);
      });
    });
  }

  /**
   *  Toggles all the slides in the container for non-trending buttons
   * @param {HTMLElement} button - Button that was clicked
   */
  function toggleDefault(button) {
    const selectorContainer = button.getAttribute("data-target-container");
    const container = document.querySelector(selectorContainer);
    let _type = button.dataset.type;

    if (_type == "by-range") {
      container
        .querySelectorAll(
          '.swiper-slide:not([data-trending="toggle"]):not([data-type="new-in"])',
        )
        .forEach((el) => {
          el.style.display = "flex";
          el.classList.remove("is-hidden");
        });
    } else if (_type == "new-in") {
      container
        .querySelectorAll(
          '.swiper-slide:not([data-trending="toggle"]):not([data-type="by-range"])',
        )
        .forEach((el) => {
          el.style.display = "flex";
          el.classList.remove("is-hidden");
        });
    }

    // container
    //   .querySelectorAll('.swiper-slide:not([data-trending="toggle"])')
    //   .forEach((el) => {
    //     el.style.display = "flex";
    //     el.classList.remove("is-hidden");
    //   });

    container.querySelectorAll(".trending-product-url").forEach((el) => {
      el.style.display = "none";
      el.classList.add("is-hidden");
    });

    // setTimeout(() => {
    //   container.style.transform = `translate3d(0px, 0px, 0px)`;
    // }, 300);
  }

  /**
   * Toggle the slides in the container for trending buttons
   * @param {HTMLElement} container - Container that contains the slides
   */
  function toggleSlides(container) {
    // console.log("container", container);
    const containerSlides = container.querySelectorAll(".swiper-slide");

    containerSlides.forEach((slide) => {
      slide.style.display = "none";
      slide.classList.add("is-hidden");
    });

    container.querySelectorAll(".trending-product-url").forEach((el) => {
      el.style.display = "flex";
      el.classList.remove("is-hidden");
    });
  }

  function checkToggle(button, container) {
    const target = button;

    if (target.dataset.search === "true" || target.dataset.search === true) {
      toggleSlides(container);
    } else {
      prepTrending(button);
    }
  }

  function prepTrending(button) {
    const target = button;

    const btnTarget = {
      id: target.getAttribute("data-target-id"),
      sectionId: target.getAttribute("data-section-id"),
      container: target.getAttribute("data-target-container"),
      slidesSelector: target.getAttribute("data-target-slides"),
      maxResults: parseInt(target.getAttribute("data-max-results")),
      facet: {
        name: target.getAttribute("data-facet-name"),
        value: target.getAttribute("data-facet-value"),
      },
    };

    const nodeSelectors = {
      container: document.querySelector(`${btnTarget.container}`),
    };

    trending(
      nodeSelectors.container,
      btnTarget.facet,
      btnTarget.maxResults,
      btnTarget.sectionId,
      button,
    );
  }

  function init() {
    addEventlistener();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
